import styled from 'styled-components';

import {
  breakpoints,
  IBasicStyledProps,
  theme,
} from '@notino/react-styleguide';

export interface IAdditionalDescriptionStyledProps extends IBasicStyledProps {
  damage?: boolean;
  highlight?: boolean;
}

export const AdditionalDescriptionStyled = styled.p<IAdditionalDescriptionStyledProps>`
  color: ${(props: IAdditionalDescriptionStyledProps) =>
    props.damage
      ? props.theme.color.text.negative
      : props.theme.color.text.secondary};

  ${theme.typography.labelRegular400};

  font-weight: ${(props: IAdditionalDescriptionStyledProps) =>
    props.highlight ? 'bold' : 'normal'};

  margin-bottom: 1.5rem !important;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 1rem !important;
  }
`;

export const StyledAdditionalText = styled.div`
  margin-top: 1rem;

  margin-bottom: 1.5rem !important;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 1rem !important;
  }
`;
